###
This class exists to have a unified interface for viewing a shapefile,
regardless of it's type. Just kind of pulls everything together.
###
class exports.Layer_Shapefile extends Handler
    constructor: () ->
        super()
        @layoutSelector = null

    onSlider: (ev, ui) =>
        for key, sub of @activeSubHandlers
            sub.onSlider(ev, ui)


    init: () ->
        @subHandlers =
            "Point":
                "class": "grower::handlers/data/layers/shapefile/Layer_Shapefile_Point"
            "Polygon":
                "class": "grower::handlers/data/layers/shapefile/Layer_Shapefile_Polygon"
            "GeoJSON":
                "class": "grower::handlers/data/layers/shapefile/Layer_Shapefile_GeoJSON"

        sub = @createSubHandler @loadLayoutPostOptions.extra_data

        if sub
            # sub = @createSubHandler("Point")    #remove this line and uncomment above
            sub.loadLayoutPostOptions = @loadLayoutPostOptions
            sub.init()

        @layer_object = sub
